import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Esto es fuerza de voluntad o motivación?',
  answer: 'No. Justamente explica por qué eso no funciona.'
}, {
  question: '¿Sirve si ya dejé pero sigo vigilándome?',
  answer: 'Sí. Es uno de los perfiles principales.'
}, {
  question: '¿Tengo que seguir reglas o hábitos estrictos?',
  answer: 'No. No hay control, retos ni vigilancia.'
}, {
  question: '¿Por cuánto tiempo tengo acceso?',
  answer: 'De por vida.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 max-w-3xl mx-auto" data-id="element-9">
      {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm" data-id="element-10">
          <button className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-11">
            <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-12">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-13" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-14" />}
          </button>

          {openIndex === index && <div className="px-6 pb-6 pt-2 text-gray-600 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-15">
              {faq.answer}
            </div>}
        </div>)}
    </div>;
}